define('BookingEngine/app-BEBasket/settings',[],function () {
    return {
        container: "#BEBasket",
        basketUrl: window.location.protocol + "//" + window.location.host + "/beupdatebasket/updatebasket"
    };
});
